import React from 'react';
import { Item } from './Item';

import s from './Documents.module.scss';

type Props = {
  title?: string;
  children?: React.ReactNode;
  tab?: boolean;
};

interface IDocuments extends React.FC<Props> {
  Item: typeof Item;
}

const Documents: IDocuments = ({ title, tab, children }: Props) => {
  const content = (
    <div data-category={title} className={s.documents__bucket}>
      <ul className={s.documents__list}>
        {React.Children.map(children, (c: JSX.Element, i) => (
          <li key={i} className={s.documents__item}>
            {c}
          </li>
        ))}
      </ul>
    </div>
  );

  const container = (
    <section className={s.documents}>
      <div className={s.documents__container}>
        <div className={s.documents__layout}>
          {title && (
            <header className={s.documents__header}>
              <h2 className={s.documents__title}>{title}</h2>
            </header>
          )}
          {content}
        </div>
      </div>
    </section>
  );

  return tab ? content : container;
};

Documents.Item = Item;

export { Documents };
